import { initContract } from "@ts-rest/core";
import { initQueryClient } from "@ts-rest/react-query";
import { AxiosError, AxiosResponse, isAxiosError, Method } from "axios";
import { api } from "../api/api";
import { API_URL } from "../api/config";
import { usersContract } from "./users.contract";
import { authContract } from "./auth.contract";
import { filesContract } from "./file.contract";
import { leaveTypeContract } from "./leave-type.contract";
import { userLeaveContract } from "./leave.contract";
import { calendarContract } from "./calendar.contract";
import { resourcesContract } from "./resources.contract";
import { profileContract } from "./profile.contract";
import { attendanceContract } from "./attendance.contract";
import { departmentContract } from "./department.contract";

// Combine all contracts
const c = initContract();
const opusContract = c.router({
	auth: authContract,
	users: usersContract,
	files: filesContract,
	leaveTypes: leaveTypeContract,
	leave: userLeaveContract,
	calendar: calendarContract,
	resources: resourcesContract,
	profile: profileContract,
	attendance: attendanceContract,
	departments: departmentContract,
});

export const opusClient = initQueryClient(opusContract, {
	baseUrl: API_URL,
	baseHeaders: {
		"content-type": "application/json",
	},
	api: async ({ path, method, headers, body }) => {
		try {
			// Remove quotes from form data values
			if (body instanceof FormData) {
				for (const [k, v] of body.entries()) {
					if (typeof v == "string") {
						body.set(k, v.slice(1, -1));
					}
				}
			}

			const result = await api.request({
				method: method as Method,
				url: path,
				headers,
				data: body,
			});

			return {
				status: result.status,
				body: result.data,
				// @ts-expect-error toJSON is not typed
				headers: new Headers(result.headers.toJSON()),
			};
		} catch (e: Error | AxiosError | any) {
			if (isAxiosError(e)) {
				const error = e as AxiosError;
				const response = error.response as AxiosResponse;
				return {
					status: response?.status,
					body: response.data,
					// @ts-expect-error toJSON is not typed
					headers: new Headers(response?.headers?.toJSON() || ""),
				};
			}
			throw e;
		}
	},
});
